import type { ErrorType, Evaluate } from '@particle-network/connector-core';
import { walletActions, type Account, type BaseErrorType, type Chain, type Transport, type WalletClient } from 'viem';
import type { Config } from '../createConfig';
import {
  getConnectorClient,
  type GetConnectorClientErrorType,
  type GetConnectorClientParameters,
} from './getConnectorClient';

export type GetWalletClientParameters = GetConnectorClientParameters;

export type GetWalletClientReturnType = Evaluate<WalletClient<Transport, Chain, Account>>;

export type GetWalletClientErrorType =
  // getConnectorClient()
  | GetConnectorClientErrorType
  // base
  | BaseErrorType
  | ErrorType;

export async function getWalletClient(
  config: Config,
  parameters: GetWalletClientParameters = {}
): Promise<GetWalletClientReturnType> {
  const client = await getConnectorClient(config, parameters);
  client.extend(walletActions);
  return client.extend(walletActions) as unknown as GetWalletClientReturnType;
}
